import Vue from "vue";
import VueRouter from "vue-router";
import { constantRouterMap } from "../config/router.config";

/**
 * 重写路由的push方法
 * 解决，相同路由跳转时
 */
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
Vue.use(VueRouter);

//console.log("base_url:" + process.env.BASE_URL);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: constantRouterMap
});

export default router;
